import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IMemberHistory, MemberHistoryService } from '../../services/member-history.service';
import { CommonModule } from '@angular/common';
import { AppSharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-member-history',
  templateUrl: './member-history.component.html',
  styleUrls: ['./member-history.component.scss'],
  standalone: true,
  imports: [CommonModule, AppSharedModule],
  host: { class: 'tw-w-full' }
})
export class MemberHistoryComponent implements OnInit {
  @Input() members: IMemberHistory[] = [];

  constructor(private readonly router: Router,
    private readonly memberHistoryService: MemberHistoryService) {}

  ngOnInit() {
    if(!this.members || this.members.length === 0) {
      this.members = [...this.memberHistoryService.getHistory()];

      this.members = this.members.map(m => ({
        ...m,
        date: m.date instanceof Date ? m.date : new Date(m.date)
      }));
    }
  }

  onRowClick(member: IMemberHistory, event: MouseEvent) {
    if (event.shiftKey) {
      window.open([`/member/${member.base64}/`].toString(), '_blank', 'noopener,noreferrer');
    } else if (event.ctrlKey) {
      this.router.navigate(['/member', member.base64]);
    } else {
      // Default action: open in a new tab
      window.open([`/member/${member.base64}/`].toString(), '_blank');
    }
  }
}
